import * as entity from '@common/domain/entities/RequisitionWorkflow'
import * as app from '@framework/app';
import { IApiServiceCommand } from '@services/api/api.service';
import { IDataEndPoint } from '@framework/interfaces/IEntity';
import { FormBuilderControlListHelper } from '../../formbuilder/FormBuilderControlListHelper';
import { ViewType } from '../../../framework/core/Enums';
export class RequisitionWorkflowEndPoints extends entity.RequisitionWorkflowEndPoints {
  search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionWorkflow/perRequisition/" + serviceCommand.context.entityId }, method: "POST" };
  pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionWorkflow/perRequisitionCount/" + serviceCommand.context.entityId }, method: "POST" };
}

export class RequisitionWorkflowFormFields extends entity.RequisitionWorkflowFormFields {
  constructor() {
    super();
	 try {
      if (this["id"]) this.splice(this.indexOf(this["id"]), 1)
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
       if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
       this.comments.viewType = ViewType.Text;
       this.comments.readOnly = true;
       this.datestamp.viewType = ViewType.DateTime;
       this.datestamp.readOnly = true;
         this.workflowId.viewType = ViewType.Dropdown;
       this.workflowId.dataEndPoint = { url: app.config.controllerRouteRoot + "/Workflow" };
       this.workflowId.dataDisplayField = "name";
       this.workflowId.dataIdField = "id";
       this.workflowId.readOnly = true;

       this.userId.dataEndPoint = { url: app.config.controllerRouteRoot + "/User" };
       this.userId.dataDisplayField = "email";
       this.userId.dataIdField = "id";
       this.userId.readOnly = true;
       this.userId.name = "User";
      // this.splice(this.indexOf(this.userId), 1)
       this.splice(this.indexOf(this.requisitionId), 1)

       this.workflowId.name = "Workflow";

    } catch  { }
  }
}

export class RequisitionWorkflowForm extends entity.RequisitionWorkflowForm {
  protected requisitionWorkflowFormEndPoints: RequisitionWorkflowEndPoints = new RequisitionWorkflowEndPoints();
  protected requisitionWorkflowFormFields: RequisitionWorkflowFormFields = new RequisitionWorkflowFormFields();

  
}

export class RequisitionWorkflowListColumns extends entity.RequisitionWorkflowListColumns {
  constructor() {
    super();
	    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
          if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
          this.workflowId.visible = false;
          this.splice(this.indexOf(this.requisitionId),1)
          this.splice(this.indexOf(this.userId), 1)
          this.splice(this.indexOf(this.comments), 1)
          this.unshift(FormBuilderControlListHelper.getListColumn("datestamp", "Date", null, null, "date_formatted"));
          this.push(FormBuilderControlListHelper.getListColumn("workflow.name", "Workflow", null, null, "workflow_name"));
          this.push(FormBuilderControlListHelper.getListColumn("userId", "User", null, null, "user"));
          this.push(this.comments)
    } catch  { }
  }
}

export class RequisitionWorkflowList extends entity.RequisitionWorkflowList {
  protected requisitionWorkflowListEndPoints: RequisitionWorkflowEndPoints = new RequisitionWorkflowEndPoints();
  protected requisitionWorkflowListColumns: RequisitionWorkflowListColumns = new RequisitionWorkflowListColumns();
}

